import { render } from "./yc-klb.vue?vue&type=template&id=8bd21330&scoped=true"
import script from "./yc-klb.vue?vue&type=script&lang=js"
export * from "./yc-klb.vue?vue&type=script&lang=js"

import "./yc-klb.vue?vue&type=style&index=0&id=8bd21330&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bd21330"]])

export default __exports__